<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">Account Settings</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    
</div>

<div class="row mx-0 myprofile">
    <div class="col-12 col-sm-12 col-md-4 col-lg-3 px-0">
        <div class="m-3 p-white shadow-sm p-3">
            <div class="d-flex align-items-center justify-content-center flex-column">
                <img src="/assets/img/default-avatar.png" style="width: 200px; height: 200px; margin-bottom: 24px;"/>
                <p class="mt-0 mb-2">Click above to upload image</p>
                <h4 class="mt-0 mb-0">Jayantha Liyanage</h4>
            </div>
            <div class="d-flex flex-column mt-4">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <b>Company</b>
                            </td>
                            <td>Hayleys Lanka (PVT) LTD</td>
                        </tr>
                        <tr>
                            <td>
                                <b>Department</b>
                            </td>
                            <td>I Note</td>
                        </tr>
                        <tr>
                            <td>
                                <b>Email</b>
                            </td>
                            <td>jayantha@heyleys.com</td>
                        </tr>
                        <tr>
                            <td>
                                <b>Phone Number</b>
                            </td>
                            <td>(032)2290888</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
        </div>
    </div>

    <div class="col col-md-8 col-lg-9 px-0">
        <div class="m-3 p-white shadow-sm  p-3">
            <h4 class="mt-0 mb-4">Reset Password</h4>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Current Password</label>
                <input type="text" pInputText> 
            </div>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">New Password</label>
                <input type="text" pInputText> 
            </div>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Re Enter New Password</label>
                <input type="text" pInputText> 
            </div>
            <div class="d-flex col mt-md-0">
                <button pButton type="button" label="Reset Password" iconPos="left" class="me-3"></button>
                <button pButton type="button" label="Clear All" class="p-button-outlined"></button>
            </div>
        </div>
    </div>

</div>